(function () {
  function qs(root, sel) { return root ? root.querySelector(sel) : null; }
  function qsa(root, sel) { return root ? Array.from(root.querySelectorAll(sel)) : []; }
  function nowId() { return String(Date.now()) + '_' + Math.random().toString(16).slice(2); }

  // ✅ NEW: escape HTML for email safety
  function escHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // =========================
  // EmailJS Config (YOUR IDS)
  // =========================
  const EMAILJS_SERVICE_ID = 'service_avzjp4b';
  const EMAILJS_TEMPLATE_ID = 'template_lijz0y3';
  const EMAILJS_PUBLIC_KEY = 'RBvi7CgJsCNYo3Qic';

  let __EMAILJS_INITED__ = false;
  function ensureEmailJSInited() {
    if (__EMAILJS_INITED__) return true;
    if (!window.emailjs || !window.emailjs.init) return false;
    try {
      // ✅ CHANGED: official v4 init signature
      window.emailjs.init({ publicKey: EMAILJS_PUBLIC_KEY });
      __EMAILJS_INITED__ = true;
      return true;
    } catch (e) {
      return false;
    }
  }

  // ---------- Google Places callback (called by script tag in liquid) ----------
  window.FenluxQuoteGoogleReady = function () {
    window.__FENLUX_GOOGLE_READY__ = true;
    document.querySelectorAll('[data-fenlux-quote]').forEach((root) => {
      if (root && root.dataset && root.dataset.fqInit === '1') {
        // already inited; try address init
        initAddressAutocomplete(root);
      }
    });
  };

  // ---------- Cart helpers ----------
  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    return await res.json();
  }

  async function addToCart(variantId, quantity, properties) {
    const payload = {
      id: parseInt(variantId, 10),
      quantity: Math.max(1, parseInt(quantity, 10) || 1),
      properties: properties || {}
    };

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    });

    if (!res.ok) throw new Error('Add failed');
    return await res.json();
  }

  async function changeCartLine(lineKey, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: Math.max(0, parseInt(quantity, 10) || 0) })
    });
    if (!res.ok) throw new Error('Change failed');
    return await res.json();
  }

  // ---------- Address Autocomplete ----------
  function initAddressAutocomplete(root) {
    try {
      if (!window.__FENLUX_GOOGLE_READY__ || !window.google || !google.maps || !google.maps.places) return;

      const input = qs(root, '[data-fq-address]');
      const placeIdField = qs(root, '#fq_address_place_id');
      const compField = qs(root, '#fq_address_components');
      if (!input || input.dataset.fqAcInit === '1') return;

      const ac = new google.maps.places.Autocomplete(input, {
        types: ['address'],
        componentRestrictions: { country: 'au' }
      });

      input.dataset.fqAcInit = '1';

      ac.addListener('place_changed', () => {
        const place = ac.getPlace();
        if (!place) return;

        if (place.formatted_address) input.value = place.formatted_address;
        if (placeIdField) placeIdField.value = place.place_id || '';

        // store components as JSON string
        if (compField) {
          const comps = (place.address_components || []).map(c => ({
            long_name: c.long_name,
            short_name: c.short_name,
            types: c.types
          }));
          compField.value = JSON.stringify({
            formatted_address: place.formatted_address || '',
            place_id: place.place_id || '',
            components: comps
          });
        }

        // mark selected
        input.dataset.fqAddressSelected = '1';
        input.classList.remove('fq-input-error');
      });

      // Fix z-index for Google Places dropdown
      input.addEventListener('focus', () => {
        setTimeout(() => {
          const pacContainer = document.querySelector('.pac-container');
          if (pacContainer) {
            pacContainer.style.zIndex = '10002';
          }
        }, 100);
      });

      // if user manually edits, force re-select from dropdown
      input.addEventListener('input', () => {
        input.dataset.fqAddressSelected = '0';
      });
    } catch (e) {
      // silent
    }
  }

  // ---------- Main init ----------
  function initFenluxQuote(root) {
    if (!root || root.dataset.fqInit === '1') return;
    root.dataset.fqInit = '1';

    // Session: only show items added during THIS quote session
    let sessionId = nowId();
    root.dataset.fqSession = sessionId;

    // Dirty tracking
    let isDirty = false;

    const backdrop = qs(root, '[data-fq-backdrop]');
    const mainModal = qs(root, '[data-fq-modal]');
    const openBtn = qs(root, '[data-fq-open]');

    const closeBtns = qsa(root, '[data-fq-close]');
    const helpModal = qs(root, '[data-help-modal]');
    const helpOpen = qs(root, '[data-help-open]');
    const helpClose = qs(root, '[data-help-close]');

    const subModals = qsa(root, '[data-sub-modal]');
    const openSubBtns = qsa(root, '[data-open-sub]');
    const subCloseBtns = qsa(root, '[data-sub-close]');

    const selectedWrap = qs(root, '#fq_selected_list');
    const refreshBtn = qs(root, '[data-fq-refresh]');

    const form = qs(root, '#fq-form');
    const cartField = qs(root, '#fq_cart_items');

    // Top level notice
    const topLevelSel = qs(root, '#fq_top_level');
    const topNotice = qs(root, '[data-topnotice]');
    const topNoteHidden = qs(root, '#fq_top_level_note');

    // Close confirm modal
    const closeConfirmModal = qs(root, '[data-fq-close-confirm]');
    const closeConfirmYes = qs(root, '[data-fq-close-confirm-yes]');
    const closeConfirmNoBtns = qsa(root, '[data-fq-close-confirm-no]');

    // Success modal
    const successModal = qs(root, '[data-fq-success]');
    const successAck = qs(root, '[data-fq-success-ack]');

    // Zoom modal
    const zoomableImg = qs(root, '[data-fq-zoomable]');
    const zoomModal = qs(root, '[data-fq-zoom-modal]');
    const zoomClose = qs(root, '[data-fq-zoom-close]');
    const zoomStage = qs(root, '[data-fq-zoom-stage]');
    const zoomImg = qs(root, '[data-fq-zoom-img]');
    const zoomOpenFull = qs(root, '[data-fq-open-full]');

    // Address fields
    const addressInput = qs(root, '[data-fq-address]');
    const placeIdField = qs(root, '#fq_address_place_id');
    const compField = qs(root, '#fq_address_components');

    // Phone
    const phoneInput = qs(root, '#fq_phone');
    const phoneWarning = qs(root, '.fq-phone-warning');

    // Gate width
    const widthInput = qs(root, '#fq_width');
    const widthWarning = qs(root, '.fq-width-warning');

    // Lower side dropdown
    const lowerSideSelect = qs(root, '#fq_lower_side');

    function lockScroll() { document.documentElement.style.overflow = 'hidden'; }
    function unlockScroll() { document.documentElement.style.overflow = ''; }

    function show(el) {
      if (!el) return;
      el.style.display = 'flex';
      if (backdrop) backdrop.style.display = 'block';
      lockScroll();
    }

    function hide(el) {
      if (!el) return;
      el.style.display = 'none';
    }

    function hideAllSubs() {
      subModals.forEach(m => hide(m));
    }

    function openMain() {
      hideAllSubs();
      hide(helpModal);
      hide(zoomModal);
      hide(closeConfirmModal);
      hide(successModal);
      // Hide error modal if visible
      const errorModal = qs(root, '[data-fq-error-modal]');
      if (errorModal) hide(errorModal);
      show(mainModal);
      // Always refresh selected items when returning to main modal
      refreshSelected();
    }

    // Also prevent form submission on submit button click if validation fails
    const submitBtn = qs(root, '[data-fq-submit]');
    if (submitBtn) {
      submitBtn.addEventListener('click', (e) => {
        // Don't prevent default here, let form submit handler deal with it
        // This is just to ensure we handle the click event
      }, false);
    }

    function reallyCloseAll() {
      // Prevent any navigation or redirects
      window.stop && window.stop();

      hide(mainModal);
      hideAllSubs();
      hide(helpModal);
      hide(zoomModal);
      hide(closeConfirmModal);
      hide(successModal);

      // Hide error modal if visible
      const errorModal = qs(root, '[data-fq-error-modal]');
      if (errorModal) hide(errorModal);

      if (backdrop) backdrop.style.display = 'none';
      unlockScroll();

      // Prevent any pending navigation
      if (window.history && window.history.pushState) {
        try {
          window.history.replaceState(null, null, window.location.href);
        } catch (e) {
          // Ignore
        }
      }
    }

    function requestClose() {
      // Only ask confirmation if user has typed or added items
      if (!isDirty) {
        reallyCloseAll();
        return;
      }
      hide(mainModal);
      hideAllSubs();
      hide(helpModal);
      hide(zoomModal);
      show(closeConfirmModal);
    }

    // ---------- mark dirty ----------
    function markDirty() { isDirty = true; }

    // any input change -> dirty
    if (form) {
      qsa(form, 'input,select,textarea').forEach(el => {
        el.addEventListener('change', markDirty);
        el.addEventListener('input', () => {
          // lightweight: input typing also counts as dirty
          markDirty();
        });
      });
    }

    // ---------- Open/Close handlers ----------
    openBtn && openBtn.addEventListener('click', () => {
      // new session each open (so second quote doesn't mix)
      sessionId = nowId();
      root.dataset.fqSession = sessionId;
      isDirty = false;

      // init google autocomplete when possible
      initAddressAutocomplete(root);

      openMain();
    });

    // Click backdrop -> request close (with confirm)
    backdrop && backdrop.addEventListener('click', requestClose);

    // Close buttons -> request close (with confirm)
    closeBtns.forEach(b => b.addEventListener('click', requestClose));

    // ESC -> request close (with confirm)
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') requestClose();
    });

    // Confirm close modal
    closeConfirmYes && closeConfirmYes.addEventListener('click', () => {
      reallyCloseAll();
    });
    closeConfirmNoBtns.forEach(btn => btn.addEventListener('click', () => {
      // go back to main instead of closing
      openMain();
    }));

    // ---------- Help modal ----------
    helpOpen && helpOpen.addEventListener('click', () => {
      hide(mainModal);
      hideAllSubs();
      hide(zoomModal);
      hide(closeConfirmModal);
      hide(successModal);
      show(helpModal);
    });
    helpClose && helpClose.addEventListener('click', openMain);

    // ---------- Sub modals open/close ----------
    openSubBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const key = btn.getAttribute('data-open-sub');
        const target = qs(root, `[data-sub-modal="${key}"]`);
        if (!target) return;

        hide(mainModal);
        hide(helpModal);
        hide(zoomModal);
        hide(closeConfirmModal);
        hide(successModal);
        show(target);

        const s = qs(target, '[data-search]');
        if (s) setTimeout(() => s.focus(), 30);
      });
    });
    subCloseBtns.forEach(btn => btn.addEventListener('click', openMain));

    // ---------- Search + card add ----------
    subModals.forEach(modal => {
      const search = qs(modal, '[data-search]');
      const cards = qsa(modal, '.fq-carditem');

      if (search) {
        search.addEventListener('input', () => {
          const q = (search.value || '').trim().toLowerCase();
          cards.forEach(card => {
            const t = (card.getAttribute('data-title') || '').toLowerCase();
            card.style.display = (!q || t.includes(q)) ? '' : 'none';
          });
        });
      }

      cards.forEach(card => {
        const addBtn = qs(card, '[data-add]');
        const varSel = qs(card, '[data-variant]');
        const qtyInput = qs(card, '[data-qty]');
        if (!addBtn) return;

        addBtn.addEventListener('click', async () => {
          const variantId = varSel ? varSel.value : null;
          const qty = qtyInput ? qtyInput.value : '1';
          if (!variantId) return;

          addBtn.disabled = true;
          const oldText = addBtn.textContent;

          try {
            const result = await addToCart(variantId, qty, {
              _fenlux_quote: '1',
              _fq_session: sessionId
            });

            markDirty();
            addBtn.textContent = 'Added ✓';
            // Refresh selected items after successful add
            await refreshSelected();
          } catch (e) {
            console.error('Failed to add to cart:', e);
            addBtn.textContent = 'Error';
            // Still try to refresh to show current state
            try {
              await refreshSelected();
            } catch (refreshError) {
              console.error('Failed to refresh selected items:', refreshError);
            }
          } finally {
            setTimeout(() => {
              addBtn.textContent = oldText || 'Add';
              addBtn.disabled = false;
            }, 900);
          }
        });
      });
    });

    // ---------- Selected items (editable qty + remove) ----------
    async function refreshSelected() {
      if (!selectedWrap) return;
      selectedWrap.innerHTML = '<div style="opacity:.7;">Loading…</div>';

      try {
        const cart = await fetchCart();
        const items = (cart && Array.isArray(cart.items)) ? cart.items : [];

        // Filter only items added in this quote session
        const filtered = items.filter(it => {
          const props = it.properties || {};
          return props._fenlux_quote === '1' && props._fq_session === sessionId;
        });

        if (filtered.length === 0) {
          selectedWrap.innerHTML = '<div style="opacity:.7;">No items added yet.</div>';
          return;
        }

        selectedWrap.innerHTML = filtered.map(item => {
          const variantTitle = item.variant_title ? `<small style="opacity:.7;">${item.variant_title}</small>` : `<small>&nbsp;</small>`;
          // Get image URL from cart item (Shopify cart API provides image as URL string)
          let imageUrl = '';
          if (item.image) {
            // Shopify cart API returns image as URL string
            imageUrl = item.image;
          } else if (item.featured_image && item.featured_image.url) {
            imageUrl = item.featured_image.url;
          } else if (item.featured_image) {
            imageUrl = item.featured_image;
          }
          // Ensure image URL is complete (add protocol if missing)
          if (imageUrl && !imageUrl.startsWith('http')) {
            imageUrl = 'https:' + imageUrl;
          }

          const imageHtml = imageUrl
            ? `<img src="${imageUrl.replace(/"/g, '&quot;')}" alt="${(item.product_title || '').replace(/"/g, '&quot;')}" style="width:72px;height:72px;object-fit:contain;border-radius:12px;background:#f3f3f3;flex-shrink:0;">`
            : `<div style="width:72px;height:72px;border-radius:12px;background:#f3f3f3;flex-shrink:0;display:flex;align-items:center;justify-content:center;color:#999;font-size:12px;">No Image</div>`;

          return `
            <div class="fq-sel-item" data-line-key="${item.key}" style="display:grid;grid-template-columns:auto 1fr auto;gap:12px;align-items:center;">
              ${imageHtml}
              <div style="min-width:0;">
                <div style="font-weight:650;">${item.product_title}</div>
                ${variantTitle}
              </div>
              <div style="display:flex;gap:8px;align-items:center;justify-content:flex-end;flex-wrap:wrap;">
                <input type="number" min="1" value="${item.quantity}" data-line-qty style="width:88px;padding:10px 12px;border-radius:12px;border:1px solid rgba(0,0,0,.14);">
                <button type="button" class="fq-remove" data-remove-line="${item.key}">Remove</button>
              </div>
            </div>
          `;
        }).join('');

        // Remove buttons
        qsa(selectedWrap, '[data-remove-line]').forEach(btn => {
          btn.addEventListener('click', async () => {
            const key = btn.getAttribute('data-remove-line');
            btn.disabled = true;
            try {
              await changeCartLine(key, 0);
              markDirty();
              await refreshSelected();
            } catch (e) {
              btn.disabled = false;
              btn.textContent = 'Error';
            }
          });
        });

        // Qty inputs
        qsa(selectedWrap, '[data-line-qty]').forEach(inp => {
          inp.addEventListener('change', async () => {
            const wrap = inp.closest('[data-line-key]');
            const key = wrap ? wrap.getAttribute('data-line-key') : null;
            if (!key) return;

            const qty = Math.max(1, parseInt(inp.value, 10) || 1);
            inp.value = String(qty);

            inp.disabled = true;
            try {
              await changeCartLine(key, qty);
              markDirty();
              await refreshSelected();
            } catch (e) {
              inp.disabled = false;
            }
          });
        });
      } catch (e) {
        selectedWrap.innerHTML = '<div style="opacity:.7;">Could not load selected items.</div>';
      }
    }

    refreshBtn && refreshBtn.addEventListener('click', refreshSelected);

    // ---------- Top level NO notice ----------
    if (topLevelSel) {
      topLevelSel.addEventListener('change', () => {
        const v = (topLevelSel.value || '').trim().toLowerCase();
        if (v === 'no') {
          if (topNotice) topNotice.style.display = '';
          if (topNoteHidden) {
            topNoteHidden.value =
              'Customer selected: NO for "Is the gate TOP level?". ' +
              'Quote should be based on the lower side ground wall/post height to ensure the gate top is levelled.';
          }
        } else {
          if (topNotice) topNotice.style.display = 'none';
          if (topNoteHidden) topNoteHidden.value = '';
        }
      });
    }

    // ---------- Phone: default 04, validate 8 more digits (total 10) ----------
    if (phoneInput) {
      // Ensure starts with 04
      if (!phoneInput.value || !phoneInput.value.startsWith('04')) {
        phoneInput.value = '04';
      }

      phoneInput.addEventListener('input', () => {
        let v = phoneInput.value || '';
        // Ensure starts with 04
        if (!v.startsWith('04')) {
          v = '04' + v.replace(/\D+/g, '');
        } else {
          v = '04' + v.substring(2).replace(/\D+/g, '');
        }
        // Limit to 10 digits total (04 + 8 digits)
        v = v.slice(0, 10);
        phoneInput.value = v;

        // Hide warning while typing
        if (phoneWarning) phoneWarning.style.display = 'none';
        phoneInput.classList.remove('fq-input-error');
      });

      phoneInput.addEventListener('blur', () => {
        const v = (phoneInput.value || '').trim();
        if (!/^04\d{8}$/.test(v)) {
          phoneInput.classList.add('fq-input-error');
          if (phoneWarning) phoneWarning.style.display = 'block';
        } else {
          phoneInput.classList.remove('fq-input-error');
          if (phoneWarning) phoneWarning.style.display = 'none';
        }
      });
    }

    // ---------- Gate width: max 6000mm validation ----------
    if (widthInput && widthWarning) {
      widthInput.addEventListener('input', () => {
        const v = parseInt(widthInput.value, 10) || 0;
        if (v > 6000) {
          widthWarning.style.display = 'block';
          widthInput.classList.add('fq-input-error');
        } else {
          widthWarning.style.display = 'none';
          widthInput.classList.remove('fq-input-error');
        }
      });

      widthInput.addEventListener('blur', () => {
        const v = parseInt(widthInput.value, 10) || 0;
        if (v > 6000) {
          widthWarning.style.display = 'block';
          widthInput.classList.add('fq-input-error');
        } else {
          widthWarning.style.display = 'none';
          widthInput.classList.remove('fq-input-error');
        }
      });
    }

    // ---------- Zoom: Fit-to-screen by default + Open full size ----------
    if (zoomableImg && zoomModal && zoomClose && zoomStage && zoomImg) {
      let zScale = 1;
      let zX = 0;
      let zY = 0;
      let dragging = false;
      let startX = 0;
      let startY = 0;

      function applyZoomTransform() {
        zoomImg.style.transform = `translate(-50%,-50%) translate(${zX}px, ${zY}px) scale(${zScale})`;
      }

      function fitToStage() {
        try {
          const stageW = zoomStage.clientWidth || 1;
          const stageH = zoomStage.clientHeight || 1;
          const nW = zoomImg.naturalWidth || 1;
          const nH = zoomImg.naturalHeight || 1;
          const fit = Math.min(stageW / nW, stageH / nH);
          zScale = Math.min(1, fit); // never auto-enlarge, just fit or smaller
          zX = 0;
          zY = 0;
          applyZoomTransform();
        } catch (e) {
          zScale = 1; zX = 0; zY = 0; applyZoomTransform();
        }
      }

      function openZoom(imgSrc) {
        // update open full size link
        if (zoomOpenFull) zoomOpenFull.href = imgSrc;

        zoomImg.onload = () => fitToStage();
        zoomImg.src = imgSrc;

        hide(mainModal);
        hideAllSubs();
        hide(helpModal);
        hide(closeConfirmModal);
        hide(successModal);
        show(zoomModal);
      }

      function closeZoom() {
        hide(zoomModal);
        show(helpModal);
      }

      zoomableImg.addEventListener('click', () => {
        const src = zoomableImg.getAttribute('src');
        if (src) openZoom(src);
      });
      zoomClose.addEventListener('click', closeZoom);

      // wheel zoom
      zoomStage.addEventListener('wheel', (e) => {
        e.preventDefault();
        const next = e.deltaY > 0 ? zScale * 0.92 : zScale * 1.08;
        zScale = Math.min(6, Math.max(0.2, next));
        applyZoomTransform();
      }, { passive: false });

      // drag move (mouse)
      zoomImg.addEventListener('mousedown', (e) => {
        dragging = true;
        startX = e.clientX - zX;
        startY = e.clientY - zY;
      });

      window.addEventListener('mousemove', (e) => {
        if (!dragging) return;
        zX = e.clientX - startX;
        zY = e.clientY - startY;
        applyZoomTransform();
      });

      window.addEventListener('mouseup', () => { dragging = false; });

      // dblclick -> toggle fit vs 2x
      zoomStage.addEventListener('dblclick', (e) => {
        e.preventDefault();
        if (zScale < 1.2) {
          zScale = 2;
          zX = 0; zY = 0;
          applyZoomTransform();
        } else {
          fitToStage();
        }
      });

      // touch pinch
      let lastDist = null;
      let lastMid = null;

      function dist(a, b) {
        const dx = a.clientX - b.clientX;
        const dy = a.clientY - b.clientY;
        return Math.sqrt(dx * dx + dy * dy);
      }
      function mid(a, b) {
        return { x: (a.clientX + b.clientX) / 2, y: (a.clientY + b.clientY) / 2 };
      }

      zoomStage.addEventListener('touchstart', (e) => {
        if (e.touches.length === 1) {
          dragging = true;
          startX = e.touches[0].clientX - zX;
          startY = e.touches[0].clientY - zY;
        } else if (e.touches.length === 2) {
          dragging = false;
          lastDist = dist(e.touches[0], e.touches[1]);
          lastMid = mid(e.touches[0], e.touches[1]);
        }
      }, { passive: true });

      zoomStage.addEventListener('touchmove', (e) => {
        if (e.touches.length === 1 && dragging) {
          zX = e.touches[0].clientX - startX;
          zY = e.touches[0].clientY - startY;
          applyZoomTransform();
        } else if (e.touches.length === 2) {
          const d = dist(e.touches[0], e.touches[1]);
          const m = mid(e.touches[0], e.touches[1]);

          if (lastDist) {
            const ratio = d / lastDist;
            zScale = Math.min(6, Math.max(0.2, zScale * ratio));
          }
          if (lastMid) {
            zX += (m.x - lastMid.x) * 0.8;
            zY += (m.y - lastMid.y) * 0.8;
          }

          lastDist = d;
          lastMid = m;
          applyZoomTransform();
        }
      }, { passive: true });

      zoomStage.addEventListener('touchend', () => {
        dragging = false;
        lastDist = null;
        lastMid = null;
      });
    }

    // ---------- Submit via AJAX + Success modal ----------
    async function buildCartSnapshotForEmail() {
      try {
        const cart = await fetchCart();
        const items = (cart && Array.isArray(cart.items)) ? cart.items : [];
        const filtered = items.filter(it => {
          const props = it.properties || {};
          return props._fenlux_quote === '1' && props._fq_session === sessionId;
        });

        const lines = filtered.map(i => {
          const sku = (i.sku || '').trim();
          const skuPart = sku ? ` (SKU: ${sku})` : '';
          const varPart = i.variant_title ? ` [${i.variant_title}]` : '';
          return `${i.quantity} x ${i.product_title}${varPart}${skuPart}`;
        });

        return lines.join(' | ');
      } catch (e) {
        return '';
      }
    }

    // ✅ NEW: build nice HTML table for EmailJS template (with images if available)
    async function buildCartItemsHtmlForEmail() {
      try {
        const cart = await fetchCart();
        const items = (cart && Array.isArray(cart.items)) ? cart.items : [];
        const filtered = items.filter(it => {
          const props = it.properties || {};
          return props._fenlux_quote === '1' && props._fq_session === sessionId;
        });

        if (!filtered.length) {
          return `<div style="padding:12px;border-radius:12px;background:#fafafa;border:1px solid rgba(0,0,0,.06);color:#666;">No items selected.</div>`;
        }

        const rows = filtered.map(i => {
          let img = i.image || (i.featured_image && i.featured_image.url) || i.featured_image || '';
          if (img && !String(img).startsWith('http')) img = 'https:' + img;

          const title = escHtml(i.product_title || '');
          const variant = escHtml(i.variant_title || '');
          const sku = escHtml(i.sku || '');
          const qty = escHtml(i.quantity || 0);

          // product url (cart item often has url)
          const url = i.url ? (location.origin + i.url) : '';

          const imgHtml = img
            ? `<img src="${escHtml(img)}" alt="${title}" style="width:54px;height:54px;object-fit:contain;border-radius:10px;border:1px solid rgba(0,0,0,.08);background:#f7f7f7;">`
            : `<div style="width:54px;height:54px;border-radius:10px;border:1px solid rgba(0,0,0,.08);background:#f7f7f7;"></div>`;

          const titleHtml = url
            ? `<a href="${escHtml(url)}" style="color:#111;text-decoration:none;font-weight:800;">${title}</a>`
            : `<div style="font-weight:800;color:#111;">${title}</div>`;

          const meta = [
            variant ? `<div style="font-size:12px;color:#666;margin-top:3px;">${variant}</div>` : '',
            sku ? `<div style="font-size:12px;color:#666;margin-top:2px;">SKU: ${sku}</div>` : ''
          ].join('');

          return `
            <tr>
              <td style="padding:10px 0;vertical-align:top;width:64px;">${imgHtml}</td>
              <td style="padding:10px 0;vertical-align:top;">
                ${titleHtml}
                ${meta}
              </td>
              <td style="padding:10px 0;vertical-align:top;text-align:right;font-weight:900;width:70px;">x ${qty}</td>
            </tr>
          `;
        }).join('');

        return `
          <table style="width:100%;border-collapse:collapse;border-top:1px solid rgba(0,0,0,.08);">
            ${rows}
          </table>
        `;
      } catch (e) {
        return `<div style="padding:12px;border-radius:12px;background:#fafafa;border:1px solid rgba(0,0,0,.06);color:#666;">(Could not load cart items)</div>`;
      }
    }

    function validateBeforeSubmit() {
      let ok = true;
      const errors = [];

      // Gate width check (max 6000mm)
      if (widthInput) {
        const v = parseInt(widthInput.value, 10) || 0;
        if (v > 6000) {
          ok = false;
          errors.push('Gate width exceeds maximum 6m (6000mm)');
          widthInput.classList.add('fq-input-error');
          if (widthWarning) widthWarning.style.display = 'block';
        } else {
          widthInput.classList.remove('fq-input-error');
          if (widthWarning) widthWarning.style.display = 'none';
        }
      }

      // native required check with field name
      if (form) {
        qsa(form, 'input[required],select[required],textarea[required]').forEach(el => {
          const fieldName = el.getAttribute('name') || el.id || '';
          const label = (el.closest('.fq-field') && el.closest('.fq-field').querySelector('label'))
            ? el.closest('.fq-field').querySelector('label').textContent.replace('*', '').trim()
            : fieldName;

          if (!el.value || !String(el.value).trim()) {
            ok = false;
            errors.push(`${label} is required`);
            el.classList.add('fq-input-error');
          } else {
            el.classList.remove('fq-input-error');
          }
        });
      }

      // phone check (must be 04 + 8 digits = 10 total)
      if (phoneInput) {
        const v = (phoneInput.value || '').trim();
        if (!/^04\d{8}$/.test(v)) {
          ok = false;
          errors.push('Phone number is required (10 digits starting with 04)');
          phoneInput.classList.add('fq-input-error');
          if (phoneWarning) phoneWarning.style.display = 'block';
        } else {
          phoneInput.classList.remove('fq-input-error');
          if (phoneWarning) phoneWarning.style.display = 'none';
        }
      }

      // address must be selected from google dropdown -> place id exists
      if (addressInput && placeIdField) {
        const selected = (addressInput.dataset.fqAddressSelected === '1') && !!placeIdField.value;
        if (!selected) {
          ok = false;
          errors.push('Address is required (please select from dropdown)');
          addressInput.classList.add('fq-input-error');
        } else {
          addressInput.classList.remove('fq-input-error');
        }
      }

      // Show error modal if validation failed (instead of alert to avoid browser domain prefix)
      if (!ok && errors.length > 0) {
        showValidationError(errors);
      }

      return ok;
    }

    // ---------- Show validation error modal ----------
    function showValidationError(errors) {
      // Create or get error modal
      let errorModal = qs(root, '[data-fq-error-modal]');
      if (!errorModal) {
        errorModal = document.createElement('div');
        errorModal.className = 'fq-modal';
        errorModal.setAttribute('data-fq-error-modal', '');
        errorModal.setAttribute('role', 'dialog');
        errorModal.setAttribute('aria-modal', 'true');
        errorModal.setAttribute('aria-label', 'Please complete required fields');
        errorModal.innerHTML = `
          <div class="fq-panel" style="max-width:560px;">
            <div class="fq-head">
              <div>
                <h3 style="margin:0;color:#333;font-size:18px;font-weight:700;">Almost there! 📝</h3>
                <div style="margin-top:8px;opacity:.8;font-size:14px;line-height:1.5;">Please complete the following required fields to submit your quote request:</div>
              </div>
              <button type="button" class="fq-close fq-close--main" data-fq-error-close aria-label="Close">✕</button>
            </div>
            <div style="margin-top:18px;padding:16px;background:rgba(250,245,240,.6);border:1px solid rgba(220,180,150,.3);border-radius:14px;border-left:4px solid rgba(255,165,0,.5);">
              <div id="fq-error-list" style="color:#555;font-size:14px;line-height:2;font-weight:400;"></div>
            </div>
            <div style="margin-top:18px;display:flex;gap:10px;flex-wrap:wrap;">
              <button type="button" class="fq-submit" data-fq-error-close style="background:#111;width:100%;">Got it, I'll complete them</button>
            </div>
          </div>
        `;
        root.appendChild(errorModal);

        // Close button handlers - return to main modal
        qsa(errorModal, '[data-fq-error-close]').forEach(btn => {
          btn.addEventListener('click', () => {
            hide(errorModal);
            // Return to main modal after closing error modal
            show(mainModal);
          });
        });

        // Close on backdrop click - return to main modal
        const closeErrorHandler = function closeErrorOnBackdrop(e) {
          if (errorModal && errorModal.style.display === 'flex' && e.target === backdrop) {
            hide(errorModal);
            // Return to main modal after closing error modal
            show(mainModal);
            // Remove this listener to avoid conflicts
            backdrop.removeEventListener('click', closeErrorHandler);
          }
        };

        // Store handler reference for later removal if needed
        if (backdrop) {
          backdrop.addEventListener('click', closeErrorHandler);
        }
      }

      // Update error list with friendly formatting
      const errorList = qs(errorModal, '#fq-error-list');
      if (errorList) {
        errorList.innerHTML = errors.map((e, i) => {
          // Make error messages more friendly
          const friendlyMsg = e
            .replace('is required', 'needs to be filled')
            .replace('required', 'needed')
            .replace('Phone number is', 'Phone number')
            .replace('Address is required', 'Address needs to be selected');
          return `<div style="display:flex;align-items:flex-start;gap:8px;"><span style="color:#ff9800;font-weight:600;flex-shrink:0;">${i + 1}.</span><span>${friendlyMsg}</span></div>`;
        }).join('');
      }

      // Hide other modals first
      hide(mainModal);
      hideAllSubs();
      hide(helpModal);
      hide(zoomModal);
      hide(closeConfirmModal);
      hide(successModal);

      // Show error modal
      show(errorModal);

      // Scroll to first error field
      const firstError = qs(root, '.fq-input-error');
      if (firstError) {
        setTimeout(() => {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
          firstError.focus();
        }, 300);
      }
    }

    // --------------------------
    // EmailJS sending helper
    // --------------------------
    async function sendQuoteEmailViaEmailJS(params) {
      // Ensure EmailJS loaded + inited
      if (!ensureEmailJSInited()) {
        throw new Error('EmailJS not loaded. Please include EmailJS script in Liquid before this JS.');
      }

      // ✅ CHANGED: include publicKey in send options for stability
      return await window.emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, params, { publicKey: EMAILJS_PUBLIC_KEY });
    }

    if (form) {
      form.addEventListener('submit', async (e) => {
        // IMPORTANT: block Shopify form submission to avoid CAPTCHA
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();

        initAddressAutocomplete(root);

        // Validate before submitting
        if (!validateBeforeSubmit()) {
          return false;
        }

        // Disable submit during sending
        const submitEl = qs(root, '[data-fq-submit]') || qs(form, 'button[type="submit"]');
        if (submitEl) submitEl.disabled = true;

        try {
          // snapshot selected items into hidden field
          const snapshot = await buildCartSnapshotForEmail();
          if (cartField) cartField.value = snapshot;

          // ✅ NEW: build HTML items table
          const itemsHtml = await buildCartItemsHtmlForEmail();

          // ensure top note
          if (topLevelSel && topNoteHidden && String(topLevelSel.value).trim().toLowerCase() === 'no' && !topNoteHidden.value) {
            topNoteHidden.value =
              'Customer selected: NO for "Is the gate TOP level?". Quote should be based on the lower side ground wall/post height to ensure the gate top is levelled.';
          }

          // Build email body (for debugging/fallback)
          const bodyField = qs(root, '#fq_body');
          if (bodyField) {
            const body = [];
            const productField = qs(root, 'input[name="contact[Product]"]');
            if (productField && productField.value) body.push('Product: ' + productField.value);

            const nameField = qs(root, '#fq_name');
            const emailField = qs(root, '#fq_email');

            if (nameField && nameField.value) body.push('Name: ' + nameField.value);
            if (emailField && emailField.value) body.push('Email: ' + emailField.value);
            if (phoneInput && phoneInput.value) body.push('Phone: ' + phoneInput.value);
            if (addressInput && addressInput.value) body.push('Address: ' + addressInput.value);

            body.push('');

            if (widthInput && widthInput.value) body.push('Gate width: ' + widthInput.value + ' mm');

            const qtyField = qs(root, '#fq_qty');
            if (qtyField && qtyField.value) body.push('Quantity: ' + qtyField.value);

            const leftHeightField = qs(root, '#fq_left_h');
            if (leftHeightField && leftHeightField.value) body.push('Gate LEFT height: ' + leftHeightField.value + ' mm');

            const rightHeightField = qs(root, '#fq_right_h');
            if (rightHeightField && rightHeightField.value) body.push('Gate RIGHT height: ' + rightHeightField.value + ' mm');

            if (lowerSideSelect && lowerSideSelect.value) body.push('Which side is lower side: ' + lowerSideSelect.value);

            const colourField = qs(root, '#fq_colour');
            if (colourField && colourField.value) body.push('Colour / finish: ' + colourField.value);

            if (topLevelSel && topLevelSel.value) {
              body.push('Is the gate TOP level: ' + topLevelSel.value);
              if (topNoteHidden && topNoteHidden.value) body.push('Note: ' + topNoteHidden.value);
            }

            body.push('');

            if (snapshot) {
              body.push('Selected items:');
              body.push(snapshot);
              body.push('');
            }

            const notesField = qs(root, '#fq_notes');
            if (notesField && notesField.value) {
              body.push('Additional notes:');
              body.push(notesField.value);
            }

            bodyField.value = body.join('\n');
          }

          // Build EmailJS params (match your template variables)
          const nameVal = qs(root, '#fq_name') ? (qs(root, '#fq_name').value || '').trim() : '';
          const emailVal = qs(root, '#fq_email') ? (qs(root, '#fq_email').value || '').trim() : '';
          const phoneVal = phoneInput ? (phoneInput.value || '').trim() : '';
          const addrVal = addressInput ? (addressInput.value || '').trim() : '';
          const dateLocal = new Date().toLocaleString('en-AU', { timeZone: 'Australia/Brisbane' });



          // ✅ Source product (from hidden inputs on product page)
const productTitle = (qs(root, 'input[name="contact[Product]"]')?.value || '').trim();
const productUrl   = (qs(root, 'input[name="contact[Product URL]"]')?.value || window.location.href || '').trim();
const productSku   = (qs(root, 'input[name="contact[SKU]"]')?.value || '').trim();




          const params = {
            reply_to: emailVal,

            customer_name: nameVal,
            customer_email: emailVal,
            customer_phone: phoneVal,
            customer_address: addrVal,


            // ✅ NEW: source product page
product_title: productTitle,
product_url: productUrl,
product_sku: productSku,






            place_id: placeIdField ? (placeIdField.value || '') : '',
            gate_width: widthInput ? (widthInput.value || '') : '',
            qty: qs(root, '#fq_qty') ? (qs(root, '#fq_qty').value || '') : '',
            left_height: qs(root, '#fq_left_h') ? (qs(root, '#fq_left_h').value || '') : '',
            right_height: qs(root, '#fq_right_h') ? (qs(root, '#fq_right_h').value || '') : '',
            lower_side: lowerSideSelect ? (lowerSideSelect.value || '') : '',
            colour: qs(root, '#fq_colour') ? (qs(root, '#fq_colour').value || '') : '',
            top_level: topLevelSel ? (topLevelSel.value || '') : '',
            top_level_note: topNoteHidden ? (topNoteHidden.value || '') : '',

            items: snapshot || '',

            // ✅ NEW: for your beautiful HTML template
            items_html: itemsHtml || '',

            notes: qs(root, '#fq_notes') ? (qs(root, '#fq_notes').value || '') : '',

            session_id: sessionId || '',
            date_local: dateLocal,

            // fallback
            body: qs(root, '#fq_body') ? (qs(root, '#fq_body').value || '') : '',
            message: qs(root, '#fq_body') ? (qs(root, '#fq_body').value || '') : ''
          };

          await sendQuoteEmailViaEmailJS(params);

          // Success: show success modal
          hide(mainModal);
          hideAllSubs();
          hide(helpModal);
          hide(zoomModal);
          hide(closeConfirmModal);

          // Hide error modal if visible
          const errorModal = qs(root, '[data-fq-error-modal]');
          if (errorModal) hide(errorModal);

          show(successModal);

          // Mark not dirty (submitted)
          isDirty = false;

        } catch (err) {
          console.error('EmailJS send failed:', err);

          showValidationError([
            'Submission failed. Please try again.',
            'If it keeps failing, please contact us directly.'
          ]);
        } finally {
          if (submitEl) submitEl.disabled = false;
        }

        return false;
      });
    }

    // Acknowledge success -> close + reset for next quote
    successAck && successAck.addEventListener('click', (e) => {
      // Prevent any default behavior
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) {
        e.stopImmediatePropagation();
      }

      console.log('Success acknowledged - closing modal only');

      // reset form fields for next quote
      if (form) form.reset();

      // reset address selection flags
      if (addressInput) {
        addressInput.dataset.fqAddressSelected = '0';
        addressInput.classList.remove('fq-input-error');
      }
      if (placeIdField) placeIdField.value = '';
      if (compField) compField.value = '';

      // reset top notice
      if (topNotice) topNotice.style.display = 'none';
      if (topNoteHidden) topNoteHidden.value = '';

      // start a new session
      sessionId = nowId();
      root.dataset.fqSession = sessionId;

      // Close all modals without any redirects
      reallyCloseAll();

      // Prevent any navigation
      return false;
    });

    // Init address if google already ready
    initAddressAutocomplete(root);

    // Fix Google Places autocomplete dropdown z-index
    if (addressInput) {
      const observer = new MutationObserver(() => {
        const pacContainer = document.querySelector('.pac-container');
        if (pacContainer) {
          pacContainer.style.zIndex = '10002';
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  // ---------- Prevent direct purchase for customise quote products ----------
  function preventDirectPurchase() {
    // Check if this is a customise quote product
    const hasQuoteSystem = document.querySelector('[data-fenlux-quote]');
    if (!hasQuoteSystem) return;

    // Block any add-to-cart forms outside the quote system
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      // Skip forms inside the quote system
      if (form.closest('[data-fenlux-quote]')) return;

      // Prevent form submission
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        console.log('Direct purchase blocked for customise quote product');
        return false;
      }, true);
    });

    // Block any direct add-to-cart button clicks
    document.querySelectorAll('button[name="add"], button[type="submit"][name="add"]').forEach(btn => {
      // Skip buttons inside the quote system
      if (btn.closest('[data-fenlux-quote]')) return;

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        console.log('Direct purchase button blocked for customise quote product');
        return false;
      }, true);
    });

    // Block any AJAX add-to-cart calls for this product
    const originalFetch = window.fetch;
    window.fetch = function (...args) {
      const url = args[0];
      // Block direct add-to-cart for this product, unless it's from quote system
      if (typeof url === 'string' && url.includes('/cart/add.js')) {
        // Check if request body contains _fenlux_quote property (from quote system)
        const options = args[1] || {};
        if (options.body) {
          try {
            const body = typeof options.body === 'string' ? JSON.parse(options.body) : options.body;
            if (body.properties && body.properties._fenlux_quote === '1') {
              // This is from quote system, allow it
              return originalFetch.apply(this, args);
            }
          } catch (e) {
            // If we can't parse body, block it to be safe
          }
        }
        // Check if request is from within quote system context
        const quoteRoot = document.querySelector('[data-fenlux-quote]');
        if (quoteRoot && document.activeElement && quoteRoot.contains(document.activeElement)) {
          return originalFetch.apply(this, args);
        }
        // Block the request
        console.log('Direct add-to-cart API call blocked for customise quote product');
        return Promise.reject(new Error('Direct purchase not allowed for customise quote products. Please use the quote system.'));
      }
      return originalFetch.apply(this, args);
    };
  }

  // Auto-init
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-fenlux-quote]').forEach(initFenluxQuote);
    preventDirectPurchase();
  });

  // Theme editor reload
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target;
    if (!section) return;
    section.querySelectorAll('[data-fenlux-quote]').forEach(initFenluxQuote);
    preventDirectPurchase();
  });
})();
